import { gql } from 'apollo-boost';
import globalConfig from 'react-global-configuration';

const LOGIN_QUERY = gql`
  query ($email: String!, $password: String!, $alias: String!) {
    login(email: $email, password: $password, alias: $alias) {
      auth
      token
      user {
        firstName
        lastName
        userId
        email
        imageUrl
        email
        preferences
        isAvailable
        initialSetup
      }
    }
  }
`;

export default (() => {
  const HIDE_FEATURES = globalConfig.get('HIDE_FEATURES') || {};

  return {
    query: LOGIN_QUERY,
    module: HIDE_FEATURES.LOGIN_VIA_IDENTITY ? 'users' : 'identity',
    ignoreCache: true,
    buildVariables: (
    { email, password, alias }) => (
    { email, password, alias })
  };
});